import { Injectable } from '@angular/core';
var CommonAction = /** @class */ (function () {
    function CommonAction() {
        this.response = {};
        this.rec = {};
    }
    CommonAction.prototype.setInit = function (state, queryParams) {
        this.state = state;
        this.queryParams = queryParams;
    };
    CommonAction.prototype.replaceParams = function (params, response, rec) {
        this.response = response;
        this.rec = rec;
        var replaceValues = {};
        if (typeof params.replace !== 'undefined') {
            for (var _i = 0, _a = Object.keys(params.replace); _i < _a.length; _i++) {
                var key = _a[_i];
                replaceValues[key] = this.getReplaceValue(params.replace[key]);
            }
        }
        if (typeof params.id !== 'undefined') {
            replaceValues['id'] = this.getReplaceValue(params.id);
        }
        if (Object.keys(replaceValues).length === 0) {
            return params;
        }
        for (var _b = 0, _c = Object.keys(replaceValues); _b < _c.length; _b++) {
            var key = _c[_b];
            params.url = this.replaceParamsValue(key, replaceValues[key], params.url);
        }
        params.query = this.replaceQuery(params.query, replaceValues);
        if (typeof params.request !== 'undefined') {
            for (var _d = 0, _e = params.request; _d < _e.length; _d++) {
                var request = _e[_d];
                request.query = this.replaceQuery(request.query, replaceValues);
                if (typeof request.id !== 'undefined') {
                    for (var _f = 0, _g = Object.keys(replaceValues); _f < _g.length; _f++) {
                        var key = _g[_f];
                        request.id = this.replaceParamsValue(key, replaceValues[key], request.id);
                    }
                }
            }
        }
        return params;
    };
    CommonAction.prototype.getReplaceValue = function (key) {
        var value;
        if (typeof key !== 'undefined') {
            if (key === 'url.id') {
                value = this.state.id;
            }
            else if (key.match(/^url\.query\./)) {
                value = this.queryParams[key.replace('url.query.', '')];
            }
            else if (key.match(/^\$/)) {
                value = jsonpath.value(this.response, key);
                if (typeof value === 'undefined') {
                    value = jsonpath.value(this.rec, key);
                }
            }
            else {
                value = this.response[key];
                if (typeof value === 'undefined') {
                    value = this.rec[key];
                }
            }
        }
        return value;
    };
    CommonAction.prototype.replaceQuery = function (query, replaceValues) {
        if (typeof query !== 'undefined' && typeof query.predicateList !== 'undefined') {
            for (var i = query.predicateList.length - 1; i >= 0; i--) {
                var predicate = query.predicateList[i];
                if (typeof predicate.value !== 'undefined') {
                    var searchKey = null;
                    for (var _i = 0, _a = Object.keys(replaceValues); _i < _a.length; _i++) {
                        var key = _a[_i];
                        if (':' + key === predicate.value) {
                            searchKey = key;
                            break;
                        }
                    }
                    if (!searchKey) {
                        continue;
                    }
                    var replaceValue = replaceValues[searchKey];
                    if (typeof replaceValue === 'undefined') {
                        query.predicateList.splice(i, 1); // delete predicate if there is no value
                    }
                    else {
                        predicate.value = this.replaceParamsValue(searchKey, replaceValue, predicate.value);
                    }
                }
            }
        }
        return query;
    };
    CommonAction.prototype.replaceParamsValue = function (searchKey, replaceValue, str) {
        if (typeof searchKey !== 'undefined' && typeof replaceValue !== 'undefined') {
            var reg = new RegExp(":" + searchKey, 'g');
            str = str.replace(reg, replaceValue);
        }
        return str;
    };
    CommonAction.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    CommonAction.ctorParameters = function () { return []; };
    return CommonAction;
}());
export { CommonAction };
//# sourceMappingURL=common.action.js.map